/*

? First, let's import the interface that will describe the shape of our property closure object.

*/

import StateInterface from "../state-interface";

export const property_closure: StateInterface["property_closure"] = {
	_id: "",
	status: "open",
	property_id: "",
	property_slug: "",
	property_name: "",
	property_type: "",
	unit: {
		unit_number: "",
		configuration: "",
		area: 0,
		area_unit: "",
	},
	buyer: {
		name: "",
		phone: {
			country_code: "",
			phone_number: "",
		},
		email: "",
		notes: "",
		lead_id: "",
		lead_source: "",
		ai_boost_id: "",
		sales_support_investment_id: "",
		campaign_id: "",
	},
	eoi: {
		is_eoi: false,
		amount: 0,
		currency: "INR",
		paid_at: new Date().toISOString(),
		payment_mode: "",
		cheque_collected: false,
		cheque_collected_at: new Date().toISOString(),
		file_id: "",
		mime_type: "",
	},
	deal: {
		currency: "INR",
		sale_value: 0,
		base_value: 0,
		booking_date: new Date().toISOString(),
		agreement_date: new Date().toISOString(),
	},
	commission: {
		currency: "INR",
		expected_percentage: 0,
		expected_amount: 0,
		actual_amount_received: 0,
		invoice_raised: false,
		payment_received: false,
		received_at: new Date().toISOString(),
		payment_transaction_id: "",
	},
	documents: [],
	created_by: {
		is_business_profile: false,
		user_id: "",
		business_profile_id: "",
	},
	internal_notes: "",
	test: false,
	created_at: new Date().toISOString(),
	updated_at: new Date().toISOString(),
	is_deleted: false,
	deleted_at: new Date().toISOString(),
};

export default property_closure;
